import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { 
			Container, 
			Button, 
			Icon, 
			Image, 
			Grid, 
			TabPane, 
			Tab,
			ListItem,
			ListHeader,
			ListDescription,
			ListContent,
			List,
 	} from 'semantic-ui-react'
import moment from 'moment'

// import game_model from 'models/game_model'
import game_play_model from 'models/game_play_model'

import ord_arr_by_spec from 'xAppLib/helpers/ord_arr_by_spec'
import time_secs_format from 'xAppLib/helpers/time_secs_format'

import { WordleWordRes } from "views/game/Wordle";


let stats_count = {}

const STATS_DICT = {
	win: 'won',
	end: 'ended/no-win',
	guess: 'started guessing',
	start: 'started typing',
	open: 'opened only',
}

const GamesStatsSum = props => {

	const [game_plays_stats, setGame_plays_stats] = useState()
	// const [gpid, setGpid] = useState()

	// const word = WORDS_DICT[Math.floor(Math.random() * WORDS_DICT.length)]

	const gid = props.match?.params?.gid || props?.params?.gid

	useEffect(() => {
		const fetchStats = async () => {
			if (!gid) return;
			
			const stats_count = await game_play_model.load_game_plays_stats(gid)
			setGame_plays_stats(stats_count)
			// console.log('game_plays_stats loaded ', stats_count, gid);
		};

		fetchStats();
	}, [gid])

	return <span>

		{/* <div style={{textAlign: 'center', padding: '1em'}}> */}

			{/* <h2>GamesStatsSum</h2> */}

			<div style={{ display: 'flex', justifyContent: 'right', flexWrap: 'wrap', gap_: '1em', width_: '150px' }}>
				{
					['win', 'end', 'guess', 'start', 'open'].map( (stat, i) => game_plays_stats?.[stat] && <React.Fragment key={i}>
							{stat}: <b>{game_plays_stats?.[stat]}</b> &nbsp; / &nbsp;
						</React.Fragment>
					)
				}
				
				tot: <b>{game_plays_stats?.tots}</b>
			</div>

		</span>
}

export default GamesStatsSum;